export function groupByFn<T, K extends string | number | symbol, R = T>(
  items: T[],
  keyFn: (item: T) => K,
  transformFn: (item: T) => R = (i) => i as unknown as R,
) {
  return items.reduce(
    (map: Record<K, R[]>, item) => {
      const k = keyFn(item);
      let list: R[] = map[k];
      if (!list) {
        list = map[k] = [];
      }
      list.push(transformFn(item));
      return map;
    },
    {} as Record<K, R[]>,
  );
}

// TODO: Rename toDictFn
export function toMapFn<T, K extends string | number | symbol, R = T>(
  items: T[],
  keyFn: (item: T) => K,
  transformFn: (item: T) => R = (i) => i as unknown as R,
) {
  return items.reduce(
    (map, item) => {
      map[keyFn(item)] = transformFn(item);
      return map;
    },
    {} as Record<K, R>,
  );
}

export function distinct<T>(items: T[]) {
  return Array.from(new Set(items));
}

/**
 * Splits list into two sublists based on the predicate.
 * Items that pass the test go into the first list, items that fail into the second.
 * @param items
 * @param predicate
 */
export function splitBy<T>(items: T[], predicate: (item: T) => boolean): [T[], T[]] {
  const truthy: T[] = [];
  const falsy: T[] = [];

  items.forEach((item) => (predicate(item) ? truthy.push(item) : falsy.push(item)));
  return [truthy, falsy];
}

export type NonNullable<T> = T extends null | undefined | false ? never : T;

export function strictIsNonNull<T>(item: T): item is NonNullable<T> {
  return item !== undefined && item !== null;
}

export function isNonNull<T>(item: T): item is NonNullable<T> {
  return !!item;
}
